import React, { FC } from 'react';
import { Box, BoxProps } from '@material-ui/core';

interface Props extends BoxProps {
  color?: 'success' | 'error' | 'warning' | 'info' | 'primary' | 'secondary';
}

const Alert: FC<Props> = ({ color = 'primary', ...props }) => {
  return (
    <Box
      px='20px'
      py='12px'
      color='#005964'
      bgcolor='#cceef3'
      border='1px solid #b8e8ee'
      borderRadius='.25rem'
      fontSize='14px'
      {...props}
    />
  );
};

export default Alert;
